import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from '../modal.service';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-modal-cancel-redeem',
  templateUrl: './modal-cancel-redeem.component.html',
  styleUrls: ['./modal-cancel-redeem.component.scss']
})
export class ModalCancelRedeemComponent implements OnInit {

  @ViewChild('cancelRedeemModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-sm', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  reward: any = {};
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private ev: EventsService
  ) { }

  ngOnInit() {
    this.modalServ.onRedeemCancel.subscribe(req => {
      console.log(req.reward);
      this.reward = req.reward;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onRedeemCancelHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm() {
    this.ngxLoading.start();
    this.api.rewardCancel(this.reward.RedeemID, '').subscribe((res: any) => {
       
      if (res.Code === 200) {
        let message = res.Message;
        const lang = localStorage.getItem('language');
        if (lang === 'th' && res.MessageAlt) {
             message = res.MessageAlt;
        } else if (lang !== 'th') {
             message = res.Message;
        }

        this.modalServ.onRedeemCancelSuccess.emit({status: 'success',message : message});
        this.ev.onReloadMyProfile.emit();
      } else {
        this.modalServ.onRedeemCancelSuccess.emit({status: 'fail',message : res.Message});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, (err: any) => {
      this.modalServ.onRedeemCancelSuccess.emit({status: 'fail',message:err.Message});
      this.hide();
      this.ngxLoading.stopAll();
    });
  }

}
